export class UserAdditionalData {
    id;
    isAcceptedMobileTermsAndPolicies;
    userId;
    kioskLoginName;
    kioskPIN;
    notes;
    isMessagingEnabled;

    constructor(id,isAcceptedMobileTermsAndPolicies, userId, kioskLoginName, kioskPIN, notes, isMessagingEnabled) {
        this.id = id;
        this.isAcceptedMobileTermsAndPolicies = isAcceptedMobileTermsAndPolicies;
        this.userId = userId;
        this.kioskLoginName = kioskLoginName;
        this.kioskPIN = kioskPIN;
        this.notes = notes;
        this.isMessagingEnabled = isMessagingEnabled;
    };
};